const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the manager assignments component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('managerAssignments', [function () {
  return {
    restrict: 'E',
    scope: {
      tab: '=',
      manager: '=',
      assignmentContent: '=',
      assignmentType: '=',
      singleUser: '=',
      usersTrigger: '=',
      forceRefresh: '=',
      managerConfiguration: '=?'
    },
    replace: true,
    template: require('../../../templates/directives/manager/manager-assignments.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      self.goToContent = function(content) {
        $scope.assignmentContent = content._id;
        $scope.assignmentType = (content.type === 'file' || content.type === 'video') ? 'media' : content.type;
        $scope.tab = 'assignment';
      };

      self.goToUser = function(user) {
        $scope.singleUser = user;
        $scope.tab = 'user';
      };

      $scope.usersTrigger = true;

      self.refresh = function() {
        self.tempHide = true;
        setTimeout(function() {
          self.tempHide = false;
          $scope.forceRefresh = false;
          $scope.$apply();
        }, 100);
        return;
      };

      $scope.$watch('manager', function(newVal, oldVal) {
        if (!newVal || !newVal._id) {
          return;
        }
        if (!oldVal || !oldVal._id) {
          return;
        }
        self.refresh();
      }, true);

      $scope.$watch('forceRefresh', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.refresh();
        }
      });
    }],
    controllerAs: 'assignments'
  };
}]);
